import merge from "lodash/merge.js";

/**
 * @param {Object} baseTheme
 * @param {Object} overrides
 */
export function overrideTheme(baseTheme, overrides) {
  return merge({}, baseTheme, { overrides });
}
